import React from 'react';
import block from 'bem-cn-lite';
import {Icon, Button} from '@yandex-data-ui/common';

import {importContext} from 'utils';
import {NavigationItem, NavigationItemType} from 'units/navigation/models';
import metrika from 'counters/metrika';
import {ServiceIcon} from 'components/ServiceIcon';

import navigationChevron from '@yandex-data-ui/page-constructor/assets/icons/navigation-chevron.svg';

import './SimpleNavigationItem.scss';

const b = block('simple-navigation-item');

// eslint-disable-next-line max-len
const socialIcons = importContext<SVGIconData>(
    require.context('@yandex-data-ui/common/assets/icons/social/', false, /\.svg$/),
);
const icons = importContext<SVGIconData>(require.context('icons/navigation/', false, /\.svg$/));

const ICON_SIZE = 16;
const ARROW_ICON_SIZE = 20;
const SOCIAL_ICON_SIZE = 24;

function prepareIconName(icon: string) {
    return icon.replace(/\//g, '-');
}

export interface SimpleNavigationItemProps extends NavigationItem {
    className?: string;
}

export default class SimpleNavigationItem extends React.Component<SimpleNavigationItemProps> {
    render() {
        const {type} = this.props;

        switch (type) {
            case NavigationItemType.Button:
                return this.renderButton();
            case NavigationItemType.Link:
                return this.renderLink();
            case NavigationItemType.ArrowLink:
                return this.renderLink(true);
            case NavigationItemType.Social:
                return this.renderSocial();
            default:
                return this.renderDafaultItem();
        }
    }

    private handleClick = () => {
        const {goal} = this.props;

        if (goal) {
            metrika.reachGoal('main', goal);
        }
    };

    private renderButton() {
        const {title, url} = this.props;

        return (
            <div className={this.getClassName()}>
                <Button view="outlined-info" href={url} onClick={this.handleClick}>
                    {title}
                </Button>
            </div>
        );
    }

    private renderLink(isArrow?: boolean) {
        const {title} = this.props;

        return (
            <a {...this.getLinkProps()}>
                {title}
                {isArrow && (
                    <Icon className={b('arrow')} data={navigationChevron} size={ARROW_ICON_SIZE} />
                )}
            </a>
        );
    }

    private renderSocial() {
        const {title, icon} = this.props;

        return (
            <a {...this.getLinkProps()} title={title} data-router="off">
                {icon && (
                    <Icon
                        className={b('social-icon')}
                        data={socialIcons[icon]}
                        size={SOCIAL_ICON_SIZE}
                    />
                )}
            </a>
        );
    }

    private renderDafaultItem() {
        const {title, icon, description, type} = this.props;

        return (
            <a {...this.getLinkProps()}>
                {icon && this.renderIcon(icon, type)}
                <div className={b('content')}>
                    <div className={b('title')}>{title}</div>
                    {description && <div className={b('description')}>{description}</div>}
                </div>
            </a>
        );
    }

    private renderIcon(icon: string, type?: NavigationItemType) {
        const iconProps = {
            size: ICON_SIZE,
            className: b('icon'),
        };

        if (type === NavigationItemType.Service) {
            return <ServiceIcon name={icon} {...iconProps} />;
        } else if (type === NavigationItemType.DefaultWithImg) {
            return <img src={icon} className={b('icon')} />;
        } else {
            const iconName = prepareIconName(icon);
            return icons[iconName] && <Icon data={icons[iconName]} {...iconProps} />;
        }
    }

    private getLinkProps() {
        const {url, blank} = this.props;

        return {
            href: url,
            className: this.getClassName(),
            ...(blank ? {target: '_blank', rel: 'noopener noreferrer'} : {}),
            onClick: this.handleClick,
        };
    }

    private getClassName() {
        const {icon, className, type = NavigationItemType.Default} = this.props;

        return b(
            {type, ['left-icon']: Boolean(icon && type !== NavigationItemType.Social)},
            className,
        );
    }
}
